import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { ManagedConfirmationPopup } from './ConfirmationPopup';

/**
 * @param props {Object}
 * @param [props.id] {string}
 * @param [props.onAccept] {Function}
 * @param [props.onDecline] {Function}
 * @param [props.acceptBtnText] {string}
 * @param [props.declineBtnText] {string}
 * @param [props.isModal=true] {boolean}
 * @param [props.articleId] {string}
 * @param [props.title] {string}
 * @param [props.content] {string}
 * @param [props.layer='COMMON'] {string}
 * @param [props.closeAll] {boolean}
 */
export const showConfirmationPopupAction = ({
    id,
    onAccept,
    onDecline,
    acceptBtnText,
    declineBtnText,
    isModal = true,
    articleId,
    title,
    content,
    layer,
    closeAll,
    ...other
}) =>
    addPopupAction({
        id,
        layer: layer || LAYER.COMMON,
        onAccept,
        onDecline,
        acceptBtnText,
        declineBtnText,
        isModal,
        articleId,
        title,
        content,
        closeAll,
        ...other,
        component: ManagedConfirmationPopup
    });
